import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { Bill, BillsListViewModel, billTypeEnumProvider} from "./billsList-viewModel"

export class BillsListView extends View<BillsListViewModel>{
    GetViewUniqueId(): string {
        return "V-F749A974-7455-4877-8A98-840C466B55C1"
    }
    loadHtml(): string {
        let element = require('./billsList.html').default;
        let style = require('./billsList.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set bills(v: ObservableArray<Bill>) { this._bills = v; } public get bills(): ObservableArray<Bill> { return this._bills;} private _bills: ObservableArray<Bill>;
    public set billTypeEnumProvider(v: billTypeEnumProvider) { this._billTypeEnumProvider = v; } public get billTypeEnumProvider(): billTypeEnumProvider { return this._billTypeEnumProvider;} private _billTypeEnumProvider: billTypeEnumProvider;
    
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

}
